export function formatUnexpectedContractValue(value: unknown) {
  if (typeof value === "string") return JSON.stringify(value);
  if (value === undefined) return "undefined";
  if (value === null) return "null";
  return `${typeof value}:${String(value)}`;
}

export function readExactStringEnumValue<T extends string>(
  context: string,
  fieldName: string,
  value: unknown,
  allowedValues: readonly T[],
): T {
  if (typeof value === "string" && allowedValues.includes(value as T)) {
    return value as T;
  }
  throw new Error(
    `${context} ${fieldName} must be one of ${allowedValues.join(", ")}, got ${formatUnexpectedContractValue(value)}`,
  );
}
